import { Container, Divider, Grid, Paper } from "@mui/material";
import { useSelector } from "react-redux";
import CantinaSaldoViewInsereCredito from "./CantinaSaldo/CantinaSaldoViewInsereCredito";
import { useEffect, useState } from "react";
import {
  findSaldoCantinaByAlunoCodigo,
  findSaldoCantinaByCurrentUser,
} from "./CantinaSaldo/api-cantina-saldo";
import { errorMessage } from "../../util/ConfirmAlertUtil";
import Loading from "../UI/Loading";
import Button from "../UI/Button";
import CantinaCreditoPageView from "./CantinaCredito/CantinaCreditoPageView";
import {
  findCantinaCreditoByAlunoCodigo,
  findCantinaCreditoByCurrentUser,
} from "./CantinaCredito/api-cantina-credito";
import {
  findCantinaExtratoByAlunoCodigo,
  findCantinaExtratoByCurrentUser,
} from "./CantinaExtrato/api-cantina-extrato";
import CantinaExtratoPageView from "./CantinaExtrato/CantinaExtratoPageView";
import AlunoProfileV2 from "../Aluno/AlunoProfileV2";
import CupomCantinaPageView from "./CupomCantina/CupomCantinaPageView";
import {
  findCupomCantinaByAlunoCodigo,
  findCupomCantinaByCurrentUser,
} from "./CupomCantina/api-cupom-cantina";
import { ALUNO, RESPONSAVEL } from "../Usuario/Perfil";

const CantinaUsuarioContainer = () => {
  const usuario = useSelector((state) => state.usuario);
  const [cantinaSaldo, setCantinaSaldo] = useState(null);
  const [isLoadingCantinaSaldo, setIsLoadingCantinaSaldo] = useState(false);
  const [isLoadingCantinaCredito, setIsLoadingCantinaCredito] = useState(false);
  const [isLoadingCantinaExtrato, setIsLoadingCantinaExtrato] = useState(false);
  const [isLoadingCupomCantina, setIsLoadingCupomCantina] = useState(false);
  const menuCreditoKey = "menu-credito";
  const menuExtratoKey = "menu-extrato";
  const menuCompraKey = "menu-compra";
  const [menu, setMenu] = useState(menuCreditoKey);

  const [pageCantinaCredito, setPageCantinaCredito] = useState({
    content: [],
    number: 0,
    size: 0,
    totalElements: 0,
  });
  const [pageCantinaExtrato, setPageCantinaExtrato] = useState({
    content: [],
    number: 0,
    size: 0,
    totalElements: 0,
  });
  const [pageCupomCantina, setPageCupomCantina] = useState({
    content: [],
    number: 0,
    size: 0,
    totalElements: 0,
  });

  useEffect(() => {
    fetchCantinaSaldo();
    // eslint-disable-next-line
  }, [usuario]);

  // useEffect(() => {
  //   fetchCantinaSaldo();
  //   // eslint-disable-next-line
  // }, [usuario.arAlunoSelecionado.codigo]);

  useEffect(() => {
    if (menu === menuCreditoKey) {
      fetchCantinaCreditoData(0);
    } else if (menu === menuExtratoKey) {
      fetchCantinaExtratoData(0);
    } else if (menu === menuCompraKey) {
      fetchCupomCantinaData(0);
      // fetchVendaCantinaData(0);
    }
    // eslint-disable-next-line
  }, [menu, usuario]);

  const fetchCantinaSaldo = () => {
    if (usuario.perfil === RESPONSAVEL) {
      setIsLoadingCantinaSaldo(true);
      findSaldoCantinaByAlunoCodigo(usuario.arAlunoSelecionado.codigo).then(
        (data) => {
          if (data) {
            if (data.error) {
              errorMessage(data.message);
            } else {
              setCantinaSaldo(data);
            }
          } else {
            setCantinaSaldo(null);
          }
          setIsLoadingCantinaSaldo(false);
        }
      );
    } else if (usuario.perfil === ALUNO) {
      setIsLoadingCantinaSaldo(true);
      findSaldoCantinaByCurrentUser().then((data) => {
        if (data) {
          if (data.error) {
            errorMessage(data.message);
          } else {
            setCantinaSaldo(data);
          }
        } else {
          setCantinaSaldo(null);
        }
        setIsLoadingCantinaSaldo(false);
      });
    }
  };

  const fetchCantinaCreditoData = (newPage) => {
    if (usuario.perfil === RESPONSAVEL) {
      setIsLoadingCantinaCredito(true);
      findCantinaCreditoByAlunoCodigo(
        usuario.arAlunoSelecionado.codigo,
        newPage
      ).then((data) => {
        if (data) {
          if (data.error) {
            errorMessage(data.message);
          } else {
            setPageCantinaCredito(data);
          }
        }
        setIsLoadingCantinaCredito(false);
      });
    } else if (usuario.perfil === ALUNO) {
      setIsLoadingCantinaCredito(true);
      findCantinaCreditoByCurrentUser(newPage).then((data) => {
        if (data) {
          if (data.error) {
            errorMessage(data.message);
          } else {
            setPageCantinaCredito(data);
          }
        }
        setIsLoadingCantinaCredito(false);
      });
    }
  };

  const fetchCantinaExtratoData = (newPage) => {
    if (usuario.perfil === RESPONSAVEL) {
      setIsLoadingCantinaExtrato(true);
      findCantinaExtratoByAlunoCodigo(
        usuario.arAlunoSelecionado.codigo,
        newPage
      ).then((data) => {
        if (data) {
          if (data.error) {
            errorMessage(data.message);
          } else {
            setPageCantinaExtrato(data);
          }
        }
        setIsLoadingCantinaExtrato(false);
      });
    } else if (usuario.perfil === ALUNO) {
      setIsLoadingCantinaExtrato(true);
      findCantinaExtratoByCurrentUser(newPage).then((data) => {
        if (data) {
          if (data.error) {
            errorMessage(data.message);
          } else {
            setPageCantinaExtrato(data);
          }
        }
        setIsLoadingCantinaExtrato(false);
      });
    }
  };

  const fetchCupomCantinaData = (newPage) => {
    if (usuario.perfil === RESPONSAVEL) {
      setIsLoadingCupomCantina(true);
      findCupomCantinaByAlunoCodigo(
        usuario.arAlunoSelecionado.codigo,
        newPage
      ).then((data) => {
        if (data) {
          if (data.error) {
            errorMessage(data.message);
          } else {
            setPageCupomCantina(data);
          }
        }
        setIsLoadingCupomCantina(false);
      });
    } else if (usuario.perfil === ALUNO) {
      setIsLoadingCupomCantina(true);
      findCupomCantinaByCurrentUser(newPage).then((data) => {
        if (data) {
          if (data.error) {
            errorMessage(data.message);
          } else {
            setPageCupomCantina(data);
          }
        }
        setIsLoadingCupomCantina(false);
      });
    }
  };

  const handleChangePageCupomCantina = (event, newPage) => {
    fetchCupomCantinaData(newPage);
  };

  const handleChangePageCantinaExtrato = (event, newPage) => {
    fetchCantinaExtratoData(newPage);
  };

  const handleChangePageCantinaCredito = (event, newPage) => {
    fetchCantinaCreditoData(newPage);
  };
  return (
    <Container component={Paper}>
      <Grid container sx={{ paddingTop: "30px" }} spacing={3}>
        {/* <Grid size={12}>
          <Typography variant="h6">Cantina</Typography>
        </Grid> */}
        {usuario.perfil === RESPONSAVEL && (
          <Grid size={12}>
            <AlunoProfileV2 />
          </Grid>
        )}

        {isLoadingCantinaSaldo ? (
          <>
            <Loading description="Carregando Cantina Saldo..." />
          </>
        ) : (
          <>
            {cantinaSaldo && (
              <Grid size={12}>
                <CantinaSaldoViewInsereCredito cantinaSaldo={cantinaSaldo} />
              </Grid>
            )}
          </>
        )}
        <Grid size={12}>
          <Divider />
        </Grid>
        <Grid size={12}>
          <Grid container justifyContent="space-around" spacing={3}>
            <Grid>
              <Button onClick={() => setMenu(menuCreditoKey)}>Crédito</Button>
            </Grid>
            <Grid>
              <Button onClick={() => setMenu(menuExtratoKey)}>Extrato</Button>
            </Grid>
            <Grid>
              <Button onClick={() => setMenu(menuCompraKey)}>Compras</Button>
            </Grid>
          </Grid>
        </Grid>
        <Grid size={12}>
          {menu === menuCreditoKey && (
            <>
              {isLoadingCantinaCredito ? (
                <Loading description="Carregando Cantina Crédito" />
              ) : (
                <CantinaCreditoPageView
                  pageCantinaCredito={pageCantinaCredito}
                  handleChangePage={handleChangePageCantinaCredito}
                />
              )}
            </>
          )}
          {menu === menuExtratoKey && (
            <>
              {isLoadingCantinaExtrato ? (
                <Loading description="Carregando Cantina Extrato" />
              ) : (
                <CantinaExtratoPageView
                  pageCantinaExtrato={pageCantinaExtrato}
                  handleChangePage={handleChangePageCantinaExtrato}
                />
              )}
            </>
          )}
          {menu === menuCompraKey && (
            <>
              {isLoadingCupomCantina ? (
                <Loading description="Carregando Cupom Cantina" />
              ) : (
                <CupomCantinaPageView
                  pageCupomCantina={pageCupomCantina}
                  handleChangePage={handleChangePageCupomCantina}
                />
              )}
              {/* {isLoadingVendaCantina ? <Loading description="Carregando Venda Cantina" /> :
                                <VendaCantinaPageView
                                    pageVendaCantina={pageVendaCantina}
                                    handleChangePage={handleChangePageVendaCantina}
                                />
                            } */}
            </>
          )}
        </Grid>
      </Grid>
    </Container>
  );
};

export default CantinaUsuarioContainer;
